import Model from './model'

export default class Screening extends Model {
  constructor() {
    super()
    this.hydrate({
      title: '',
      screening_date: '',
      start_time: '',
      end_time: '',
      file: '',
      active: false,
    })
  }
}